'use client';

import { c as _c } from "react/compiler-runtime";
import ROUTES from '@lib/constants/routes';
import { activeQueueSelector } from '@lib/store/slices/VisualSlice';
import { useParams } from 'next/navigation';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Tab from '../tab-button/Tab';
const VisualNav = t0 => {
  const $ = _c(32);
  const {
    mobTabStyle,
    mobTabActiveStyle,
    page,
    mobTabBehindStyle
  } = t0;
  const activeQueue = useSelector(activeQueueSelector);
  const {
    houseId,
    bulkId,
    floorId
  } = useParams();
  const rootLink = `${ROUTES.flats.visual.root}`;
  const bulkLink = `${ROUTES.flats.visual.root}/${houseId}`;
  const floorLink = `${ROUTES.flats.visual.root}/${houseId}/${bulkId}`;
  const flatLink = `${ROUTES.flats.visual.root}/${houseId}/${bulkId}/${floorId}`;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      id: 0,
      text: "\u041E\u0447\u0435\u0440\u0435\u0434\u044C",
      isActive: false,
      link: rootLink,
      disabled: false,
      hide: false,
      isBehind: false
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== bulkLink) {
    t2 = {
      id: 1,
      text: "\u041A\u043E\u0440\u043F\u0443\u0441",
      isActive: false,
      link: bulkLink,
      disabled: false,
      hide: false,
      isBehind: false
    };
    $[1] = bulkLink;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== floorLink) {
    t3 = {
      id: 2,
      text: "\u042D\u0442\u0430\u0436",
      isActive: false,
      link: floorLink,
      disabled: false,
      hide: false,
      isBehind: false
    };
    $[3] = floorLink;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== flatLink) {
    t4 = {
      id: 3,
      text: "\u041A\u0432\u0430\u0440\u0442\u0438\u0440\u0430",
      isActive: false,
      link: flatLink,
      disabled: false,
      hide: false,
      isBehind: false
    };
    $[5] = flatLink;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
    t5 = [t1, t2, t3, t4];
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const [tabs, setTabs] = useState(t5);
  let t6;
  if ($[11] !== activeQueue || $[12] !== houseId || $[13] !== page || $[14] !== tabs) {
    t6 = () => {
      const updatedTabs = tabs.map(tab => {
        if ((Number(houseId) === 1 || !houseId) && (activeQueue === 1 || activeQueue === null) && tab.id === 1) {
          return {
            ...tab,
            hide: true
          };
        }
        if (tab.id === page - 1) {
          return {
            ...tab,
            isActive: true,
            hide: false
          };
        }
        return {
          ...tab,
          isActive: false,
          hide: false
        };
      });
      const activeTabId = updatedTabs.find(_temp).id;
      const finalTabs = updatedTabs.map(tab_1 => ({
        ...tab_1,
        disabled: tab_1.id > activeTabId,
        isBehind: tab_1.id < activeTabId
      }));
      if (JSON.stringify(finalTabs) !== JSON.stringify(tabs)) {
        setTabs(finalTabs);
      }
    };
    $[11] = activeQueue;
    $[12] = houseId;
    $[13] = page;
    $[14] = tabs;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== activeQueue || $[17] !== page) {
    t7 = [activeQueue, page];
    $[16] = activeQueue;
    $[17] = page;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  useEffect(t6, t7);
  let t8;
  if ($[19] !== mobTabActiveStyle || $[20] !== mobTabBehindStyle || $[21] !== mobTabStyle || $[22] !== page || $[23] !== tabs) {
    let t9;
    if ($[25] !== mobTabActiveStyle || $[26] !== mobTabBehindStyle || $[27] !== mobTabStyle || $[28] !== page) {
      t9 = item => <Tab key={item.id} {...item} isActive={item.isActive} mobTabActiveStyle={mobTabActiveStyle} mobTabStyle={mobTabStyle} page={page} mobTabBehindStyle={mobTabBehindStyle} />;
      $[25] = mobTabActiveStyle;
      $[26] = mobTabBehindStyle;
      $[27] = mobTabStyle;
      $[28] = page;
      $[29] = t9;
    } else {
      t9 = $[29];
    }
    t8 = tabs.map(t9);
    $[19] = mobTabActiveStyle;
    $[20] = mobTabBehindStyle;
    $[21] = mobTabStyle;
    $[22] = page;
    $[23] = tabs;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[30] !== t8) {
    t9 = <>{t8}</>;
    $[30] = t8;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  return t9;
};
export default VisualNav;
function _temp(tab_0) {
  return tab_0.isActive;
}